import userInfo from "../../function/userInfo";
import * as API from "../ApiConfig";

export default {
  DoGetAutoCompleteAssetTemplate(searchText) {
    let _input = {
      assetSubCategoryId: 0,
      assetCategoryId: 0,
      searchText: searchText,
    };

    return API.peakRealTimeAPI
      .post("/api/Asset/GetAutoCompleteAssetTemplate", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetAutoCompleteAsset(input) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      assetTemplateId: input.assetTemplateId,
      searchText: input.searchText,
    };
    return API.peakAPI.post("/api/Asset/GetAutoCompleteAsset", _input, userInfo.SetHeaderService()).then((res) => {
      return res;
    });
  },
  GetAssetTemplateListById(assetTemplateIdList) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      assetTemplateIdList: assetTemplateIdList,
    };
    return API.peakRealTimeAPI
      .post("/api/Asset/GetAssetTemplateListById", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  GetAssetCodeByIdList(assetIdList) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      assetIdList: assetIdList,
    };
    return API.peakRealTimeAPI
      .post("/api/Asset/GetAssetCodeByIdList", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetAssetTemplateCodeByAssetTemplateIdList(assetTemplateIdList) {
    let _input = {
      assetTemplateIdList: assetTemplateIdList,
    };
    return API.peakAPI
      .post("/api/Asset/GetAssetTemplateCodeByAssetTemplateIdList", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoCreateAssetTemplate(assetTemplateList) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      assetTemplateList: assetTemplateList,
    };
    return API.peakRealTimeAPIForImport
      .post("/api/Asset/InsertAssetTemplate", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoUpdateAssetTemplate(assetTemplate) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      assetTemplate: assetTemplate,
    };
    return API.peakRealTimeAPIForImport
      .post("/api/Asset/UpdateAssetTemplate", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetSuggestionAssetTemplateCode(assetTemplateSubCategoryType) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      assetTemplateSubCategoryType: assetTemplateSubCategoryType,
    };
    return API.peakRealTimeAPI
      .post("/api/Asset/GetSuggestionAssetTemplateCode", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetAssetTemplateValidateIsCanVoid(assetTemplateIdList) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      assetTemplateIdList: assetTemplateIdList,
    };
    return API.peakRealTimeAPI
      .post("/api/Asset/GetAssetTemplateValidateIsCanVoid", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetAssetTemplateCategoryMenu() {
    let _input = {
      merchantId: userInfo.MerchantId(),
    };
    return API.peakAPI
      .post("/api/Asset/GetAssetTemplateCategoryMenu", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetAssetTemplateCacheCount() {
    return API.peakAPI
      .post("/api/Asset/GetAssetTemplateCacheCountByMerchantId", {}, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetAssetTemplateCache(input) {
    let _input = {
      pageNo: input.pageNo,
      pageSize: input.pageSize,
    };
    return API.peakAPI
      .post("/api/Asset/GetAssetTemplateCacheByMerchantId", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
};
